import React from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import { all_routes } from '../../../router/all_routes'
import { Link } from 'react-router-dom';


interface BannerProps {
    apiValues: any;
}



const Benefits: React.FC<BannerProps> = ({ apiValues }) => {

    const route = all_routes;


    return (
        <>
            {/* benefits */}
            <section className="benefit-section bg-[#E7E7E7] text-justify">
                <div className="container">
                    <div className="section-header text-start">
                        <span className="fw-medium text-secondary mb-2 d-inline-block">
                            {apiValues?.title || "Why Choose Us?"}
                        </span>
                        <h2 className='!text-[#1D1753]'>
                            {apiValues?.description}
                        </h2>
                        <p>
                            {
                                apiValues?.miniDescription
                            }
                        </p>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {(Array.isArray(apiValues?.whyPalanivelCards) ? apiValues?.whyPalanivelCards : []).map(
                            (item: any, index: number) => (
                                <div key={index} className="flex">
                                    <div className="card newGradient card-hover-effect w-full h-full flex flex-col">
                                        <div className="card-body p-4 flex flex-col h-full">
                                            {/* Icon */}
                                            <div className="flex items-center justify-start">
                                                <div className="p-2 rounded-full bg-[#FFEDF0] flex items-center justify-center">
                                                    <ImageWithBasePath
                                                        source={item?.iconUrl}
                                                        className="rounded-full"
                                                        style={{ width: 40, height: 40 }}
                                                        alt="Img"
                                                    />
                                                </div>
                                            </div>

                                            {/* Title */}
                                            <h5 className="mt-3 mb-1 !text-[#1D1753]">{item.title}</h5>

                                            {/* Description grows to push button down */}
                                            <p className="!text-[#1D1753] mb-2 flex-grow">{item.description}</p>

                                            {/* Button at bottom */}
                                            {/* <Link to={`${route.learnMore}/${item._id}`} className="mt-auto"> */}
                                            <Link to={item._id == "68970c97c7c75fef7700668a"?
                                                "/Contact":"/course_advice"}
                                             className="mt-auto">
                                            
                                                <button className="learn-more-btn">
                                                    <span className="btn-text">{item.buttonText}</span>
                                                    <span className="btn-arrow">→</span>
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            )
                        )}
                    </div>


                </div>
            </section >
            {/* benefits */}
        </>

    )
}

export default Benefits
